import React from 'react';
import { ReactComponent as TokenSvg } from '../assets/wallpass-token.svg';
import { ReactComponent as TokenFlatSvg } from '../assets/wallpass-token-flat.svg';

// The WallPass token coin. `flat` (default) is the two-color variant that
// stays crisp at small sizes; pass flat={false} for the detailed gradient
// coin at 40px and up (logos, balance cards).
const TokenIcon = ({ size = 16, flat = true, className = '' }) => {
  const Svg = flat ? TokenFlatSvg : TokenSvg;
  return (
    <Svg
      width={size}
      height={size}
      className={`inline-block align-[-0.125em] shrink-0 ${className}`}
      aria-hidden="true"
    />
  );
};

export default TokenIcon;
